import React, { useEffect, useState, useRef } from "react";
import { Box, Typography, Grid } from "@mui/material";
import NftCard from "../../components/NftCard";
import ApiService from "../../services/api-service";
import { getUserId, getErrorString } from "../../constants/function";
import notifier from "../../components/Notifier";

export default function CollectionTab() {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const containerRef = useRef(null);

  const fetchCollections = async (nextPage = 1) => {
    try {
      setLoading(true);
      const response = await ApiService.USER_NFT_MUSIC({
        userId: getUserId(),
        pageSize: 20,
        pageNo: nextPage,
      });
      const newItems = response.result || [];
      setCollections(prev => nextPage === 1 ? newItems : [...prev, ...newItems]);
      setHasMore(newItems.length === 20); // If less than 20, no more pages
    } catch (error) {
      notifier.error(getErrorString(error));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCollections(1);
    setPageNo(1);
  }, []);

  // Infinite scroll handler
  const handleScroll = () => {
    const el = containerRef.current;
    if (
      el &&
      hasMore &&
      !loading &&
      el.scrollTop + el.clientHeight >= el.scrollHeight - 100
    ) {
      fetchCollections(pageNo + 1);
      setPageNo(pageNo + 1);
    }
  };

  return (
    <Box sx={{ color: "var(--text-primary, #fff)", mt: 4, height: "calc(100vh - 64px)", overflowY: "auto", pl: 6, }} ref={containerRef} onScroll={handleScroll}>
      <Typography variant="h5">Collection</Typography>
      <Box sx={{ mt: 4 }}>
        {loading && collections.length === 0 ? (
          <Typography color="var(--text-primary, #fff)">Loading...</Typography>
        ) : collections.length === 0 ? (
          <Typography color="var(--text-primary, #fff)">No NFTs in your collection.</Typography>
        ) : (
          <Grid container spacing={4} rowSpacing={14}>
            {collections.map(nft => (
              <Grid item xs={12} sm={6} md={4} lg={2.4} key={nft._id}>
                <NftCard nft={nft} />
              </Grid>
            ))}
          </Grid>
        )}
        {loading && collections.length > 0 && (
          <Typography sx={{ mt: 2, textAlign: "center", color: "var(--text-primary, #fff)" }}>Loading more...</Typography>
        )}
      </Box>
    </Box>
  );
}